import React from 'react';
import Typography from 'components/Typography';
import { TextWrapper } from './style';

//"notificationText": "最新のお知らせが届いています。こちらのボタンからご確認ください",
//
const ResponsiveText = ({ text }) => {
  const [lineCount, setLineCount] = React.useState(1);

  React.useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 450) {
        setLineCount(3);
      } else if (width < 700) {
        setLineCount(2);
      } else {
        setLineCount(1);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let lines = [];

  if (lineCount === 2) {
    const sentences = text.split('。').filter(Boolean); 
    const chunkSize = Math.ceil(sentences.length / 2);

    lines = Array.from({ length: 2 }, (_, i) =>
      sentences.slice(i * chunkSize, (i + 1) * chunkSize).join('。') + '。'
    );
  } else {
    const characters = text.split('');
    const chunkSize = Math.ceil(characters.length / lineCount);
    lines = Array.from({ length: lineCount }, (_, i) =>
      characters.slice(i * chunkSize, (i + 1) * chunkSize).join('')
    );
  }

  return (
    <TextWrapper>
      {lines.map((line, index) => (
        <Typography key={index} variant="default">
          {line}
        </Typography>
      ))}
    </TextWrapper>
  );
};

export default ResponsiveText;
